import { render, staticRenderFns } from "./collectionItem.vue?vue&type=template&id=0decec53&scoped=true"
import script from "./collectionItem.vue?vue&type=script&lang=js"
export * from "./collectionItem.vue?vue&type=script&lang=js"
import style0 from "./collectionItem.vue?vue&type=style&index=0&id=0decec53&prod&lang=less&scoped=true"
import style1 from "./collectionItem.vue?vue&type=style&index=1&id=0decec53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0decec53",
  null
  
)

export default component.exports